export default {

	/*******************************************************
	* brand config
	*	brand => config
	*******************************************************/
    'century-arms': {
        params: {
            brand: 'century arms'
        }
    },
    'glock': {
        params: {
            brand: 'glock',
            keywords: 'glock'
        }
    },
	'hipoint': {
        params: {
            brands: 'hipoint,hi-point,hi point'
        }
	},
    "kel-tec": {
        params: {
            brands: 'kel tec,kel-tec'
        }
    },
    "bcm": {
        params: {
            keywords: "Bravo Company Manufacturing rifle"
        }
    },
    "iwi": {
        params: {
            brands: "iwi us"
        }
    }

};